import { render } from "./DashyBoard.vue?vue&type=template&id=1ccf3742&scoped=true"
import script from "./DashyBoard.vue?vue&type=script&lang=js"
export * from "./DashyBoard.vue?vue&type=script&lang=js"

import "./DashyBoard.vue?vue&type=style&index=0&id=1ccf3742&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccf3742"]])

export default __exports__